import {
  useChatHeaderTodoInstance,
  useSiderTodoBadge,
  useClearChatHeaderTodoInstance,
} from 'hooks/business/useSiderTodoBadge';
import { useTranslate } from '@tolgee/react';
import { useGetTodoTypeLabel } from 'views/Todo/hooks/useLabel';
import { Button } from 'antd';
import { useCloseTodo } from 'views/Conversation/Sider/ToDoBundle/useApi';
import { useState } from 'react';
import { eventBus } from 'services/eventBus';

const TodoRelatedMe = (props: { todoInstance: Todo.TodoInstance }) => {
  const { todoInstance } = props;
  const { t } = useTranslate();
  const { getTodoTypeLabel } = useGetTodoTypeLabel();
  const clearChatHeaderTodoInstance = useClearChatHeaderTodoInstance();
  const closeTodo = useCloseTodo();
  const [closeLoading, setCloseLoading] = useState(false);

  const { type, typeName } = todoInstance;

  const handleCloseTodo = async () => {
    setCloseLoading(true);
    try {
      await closeTodo(false, todoInstance.id);
      clearChatHeaderTodoInstance();
    } finally {
      setCloseLoading(false);
    }
  };

  const handleViewTodo = () => {
    eventBus.emit('SIDER_TODO_LOCATE', todoInstance);
  };

  return (
    <div className="bg-[#F0F7FF] py-1.5 px-4 text-xs text-[#515359] flex items-center justify-between">
      <span>{t('当前会话有x待办项等待处理', { x: getTodoTypeLabel(type, typeName) })}</span>
      <div>
        <Button
          className="!text-xs"
          size="small"
          type="link"
          onClick={handleCloseTodo}
          loading={closeLoading}
        >
          {t('operateType.CLOSE')}
        </Button>
        <Button className="!text-xs" size="small" type="link" onClick={handleViewTodo}>
          {t('查看待办')}
        </Button>
      </div>
    </div>
  );
};

export function TodoTips() {
  const badgeType = useSiderTodoBadge();
  const todoInstance = useChatHeaderTodoInstance();
  const { getTodoTypeLabel } = useGetTodoTypeLabel();
  const { t } = useTranslate();

  if (!badgeType || !todoInstance) return null;

  if (badgeType === 'blue') {
    const { type, typeName } = todoInstance;
    return (
      <div className="bg-[#F0F7FF] py-1.5 px-4 text-xs text-[#515359]">
        {t('x正在处理y待办项', {
          x: todoInstance.operatorName,
          y: getTodoTypeLabel(type, typeName),
        })}
      </div>
    );
  }

  if (badgeType === 'red') {
    return <TodoRelatedMe todoInstance={todoInstance} />;
  }

  return null;
}
